import { parseDate, parseTime } from "./parser"

/**
 * Finds a date and time property with the specified names.
 * @return the date as an ISO 8601 formatted string
 */

export const findProp = (props, names) => {
  if (!props) return false;

  var keys = Object.keys(props);
  for (let x = 0; x < keys.length; x++) {
    for (let y = 0; y < names.length; y++) {
      if ((keys[x].toLowerCase().indexOf(names[y]) == 0) && (keys[x].length == names[y].length)) {
        return props[keys[x]];
      }
    }
  }

  return false;
}

export const findDateTime = (props, dateNames, timeNames, dateFormat) => {
  var date = parseDate(findProp(props, dateNames), dateFormat),
      time = parseTime(findProp(props, timeNames));

  if (date) {
    if (time) {
      date = `${date}T${time}`;
    }
  }

  return date;
}

export const findUnits = (item) => {
  var units = findProp(item.properties, ['units']);
  if (units) {
    return ~~units;
  }

  return item.quantity;
}

export const findStartDateTime = (props, dateFormat) => {
  return findDateTime(
    props,
    ['booking-start', 'date', 'start', 'booking', 'event', 'from', 'delivery', 'delivery date', 'service date', 'día'],
    ['start-time', 'booking-time', 'time', 'hora'],
    dateFormat
  );
}

export const findFinishDateTime = (props, dateFormat) => {
  return findDateTime(
    props,
    ['booking-finish', 'booking-end', 'to', 'finish', 'return', 'return date'],
    ['finish-time'],
    dateFormat
  );
}
